var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_24442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58897 0 0 3.58897 0 8C0 12.411 3.58897 16 8 16C12.411 16 16 12.411 16 8C16 3.58897 12.411 0 8 0ZM8 15.4483C3.89241 15.4483 0.551724 12.1076 0.551724 8C0.551724 3.89241 3.89241 0.551724 8 0.551724C12.1076 0.551724 15.4483 3.89241 15.4483 8C15.4483 12.1076 12.1076 15.4483 8 15.4483ZM12.4441 5.10069C12.5517 5.20828 12.5517 5.38207 12.4441 5.48966L7.42345 10.5103C7.37103 10.5628 7.30207 10.5903 7.22759 10.5903C7.1531 10.5903 7.08414 10.56 7.03172 10.5103L4.32828 7.8069C4.22069 7.69931 4.22069 7.52552 4.32828 7.41793C4.43586 7.31034 4.60966 7.31034 4.71724 7.41793L7.22483 9.92552L12.0497 5.10069C12.16 4.9931 12.3366 4.9931 12.4441 5.10069Z",
    fill: "#FF7010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_24442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.db660677d26b39daed96b006f13e79d9.svg";
export { ForwardRef as ReactComponent };